import PropTypes from 'prop-types';
import {Box, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site';
import {BNPL_PAGE_TYPE} from '@amblique/king-living/app/constants/bnpl-messaging';
import {useBnplMessagingConfig} from '@amblique/king-living/app/hooks/use-bnpl-messaging-config';
import {
  getAfterpayLocale,
  getBnplProviderVisibility,
  getCurrencySymbol,
} from '@amblique/king-living/app/utils/bnpl-messaging-utils';
import AfterpayMessaging from './afterpay-messaging';
import ZipMessaging from './zip-messaging';

const BuyNowPayLaterMessaging = ({
  amount,
  currency,
  isEligible = true,
  pageType,
  ...rest
}) => {
  const styles = useMultiStyleConfig('BuyNowPayLaterMessaging', {});
  const {locale} = useMultiSite();
  const config = useBnplMessagingConfig();
  const {afterpayAmount, showAfterpay, showZip, zipPrice} = getBnplProviderVisibility(config, amount);
  const resolvedCurrency = currency || 'AUD';

  if (!showAfterpay && !showZip) {
    return null;
  }

  return (
    <Box className="bnpl-messaging" {...styles.root} {...rest}>
      {showAfterpay && (
        <AfterpayMessaging
          amount={afterpayAmount}
          config={config.afterpay}
          currency={resolvedCurrency}
          isEligible={isEligible}
          locale={getAfterpayLocale(resolvedCurrency, locale?.id)}
          pageType={pageType}
          styles={styles}
        />
      )}

      {showZip && (
        <ZipMessaging
          key={zipPrice}
          amount={zipPrice}
          config={config.zip}
          currencySymbol={getCurrencySymbol(resolvedCurrency)}
          pageType={pageType}
          styles={styles}
        />
      )}
    </Box>
  );
};

BuyNowPayLaterMessaging.displayName = 'BuyNowPayLaterMessaging';
BuyNowPayLaterMessaging.propTypes = {
  amount: PropTypes.number,
  currency: PropTypes.string,
  isEligible: PropTypes.bool,
  pageType: PropTypes.oneOf([BNPL_PAGE_TYPE.PRODUCT, BNPL_PAGE_TYPE.CART]).isRequired,
};

export default BuyNowPayLaterMessaging;
export {BNPL_PAGE_TYPE};
